import { Tabs } from "@ark-ui/react";
import clsx from "clsx";
import type { ComponentProps } from "react";
import { useTabsContext } from "../TabsContext";

type Props = ComponentProps<typeof Tabs.Trigger>;

const Trigger = ({ value, className, ...rest }: Props) => {
  const { layout, color } = useTabsContext();

  const isFilled = layout === "fill";

  return (
    <Tabs.Trigger
      value={value}
      className={clsx(
        "text-center text-gray-500 text-label2",
        "[&:is([data-selected],[data-focused])]:font-semibold",
        color === "primary"
          ? "[&:is([data-selected])]:text-primary-500"
          : color === "secondary"
            ? "[&:is([data-selected])]:text-blue-400"
            : undefined,
        isFilled && "flex-1",
        className,
      )}
      {...rest}
    />
  );
};

export default Trigger;
